import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../lib/data";

export default function Reviews() {
  return (
    <section id="bewertungen" className="relative py-20 md:py-28 bg-ink-surface" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-volt" />
              <span className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-volt">Kundenstimmen</span>
            </div>
            <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
              className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-white leading-[0.95]">
              Das sagen <span className="text-volt">unsere Kunden</span>
            </motion.h2>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-6 w-6 fill-volt text-volt" />)}
            </div>
            <span className="text-white/70 font-semibold text-sm">5,0 / 5 · Zufriedene Kunden</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.div key={r.name} data-testid={`review-${i}`}
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.1 }}
              className="group relative rounded-2xl bg-ink border border-white/[0.06] p-7 hover:border-volt/60 transition-all duration-500 hover:-translate-y-1.5 flex flex-col">
              <Quote className="h-8 w-8 text-volt/30 group-hover:text-volt/60 transition-colors" />
              <div className="flex gap-1 mt-4 mb-3">
                {[...Array(r.rating)].map((_, s) => <Star key={s} className="h-4 w-4 fill-volt text-volt" />)}
              </div>
              <p className="text-white/70 text-sm leading-relaxed grow">"{r.text}"</p>
              <div className="mt-6 pt-5 border-t border-white/[0.06]">
                <div className="font-heading font-bold text-white">{r.name}</div>
                <div className="text-volt text-xs font-semibold mt-0.5">{r.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
